import React from "react"
import { connect } from 'react-redux'
import styled from "styled-components"
import Layout from "../components/layout/index.js"
import Tags from "../components/Tags/index.js"
import { unit } from "../utils/utils"

const TagsTitle = styled.h3`
  width: 100%;
  padding: 1rem 0;
  border-bottom: 1px solid #c8c8c8;
  display: inline;
`

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
`

const TagPage = () => {

  const onClickTag = tag => {
  }

  return (
    <Layout>
      <Container>
        <TagsTitle onClick={onClickTag}>All Tags</TagsTitle>
        <Tags />
      </Container>
    </Layout>
  )
}

export default TagPage